module.exports = __webpack_public_path__ + "static/sparkles-gif-488fa0aa3fe439b3cced4e3f67b30c94.gif";